import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { C } from '../../styles/tokens';

// ── Centered confirm dialog — matches this app's token-based design, used in place of the
// browser's native window.confirm() for delete actions across Dubbing/Voice Changer/Isolator ──
export default function ConfirmDialog({
    open,
    title = 'Are you sure?',
    message,
    confirmLabel = 'Delete',
    cancelLabel = 'Cancel',
    danger = true,
    confirmDisabled = false,
    onConfirm,
    onCancel,
}) {
    useEffect(() => {
        if (!open) return;
        const onKey = e => { if (e.key === 'Escape') onCancel(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [open, onCancel]);

    if (!open) return null;

    return createPortal(
        <div
            onClick={onCancel}
            style={{
                position: 'fixed', inset: 0, zIndex: 1100, background: 'rgba(15,23,42,.45)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
            }}
        >
            <div
                onClick={e => e.stopPropagation()}
                style={{
                    width: 360, maxWidth: '100%', background: C.w, borderRadius: 16,
                    boxShadow: '0 20px 60px rgba(0,0,0,.22)', padding: '22px 22px 18px',
                }}
            >
                <div style={{ fontSize: 16, fontWeight: 700, color: C.n900, marginBottom: 6 }}>{title}</div>
                {message && (
                    <div style={{ fontSize: 13.5, color: C.n500, lineHeight: 1.5, margin: '0 0 20px' }}>{message}</div>
                )}
                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                    <button
                        type="button"
                        onClick={onCancel}
                        style={{
                            padding: '9px 16px', borderRadius: 9, border: `1px solid ${C.n200}`,
                            background: C.w, color: C.n600, fontSize: 13.5, fontWeight: 600,
                            cursor: 'pointer', fontFamily: 'inherit',
                        }}
                    >
                        {cancelLabel}
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={confirmDisabled}
                        style={{
                            padding: '9px 18px', borderRadius: 9, border: 'none',
                            background: confirmDisabled ? C.n300 : (danger ? '#EF4444' : C.n900), color: C.w,
                            fontSize: 13.5, fontWeight: 700, fontFamily: 'inherit',
                            cursor: confirmDisabled ? 'not-allowed' : 'pointer',
                        }}
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}
